// FR | EN. The console ships both languages, so nobody needs the browser's
// page translation, which rewrites React's text and blanks the page.
import { LANG, S } from '../lib/strings';

export function LangSwitch() {
  const pick = (l: 'fr' | 'en') => {
    if (l === LANG) return;
    try { localStorage.setItem('ops-lang', l); } catch { /* private window: stays French */ }
    location.reload();
  };
  return (
    <div className="lang" role="group" aria-label={S.lang}>
      {(['fr', 'en'] as const).map((l) => (
        <button key={l} type="button" className={l === LANG ? 'on' : ''} aria-pressed={l === LANG} onClick={() => pick(l)}>{l.toUpperCase()}</button>
      ))}
    </div>
  );
}
